import type { ApiResponse } from '../api-types'

import type { Flow, FlowPayload } from './flows-types'
import { api } from '@/api/api'

export const flowsService = {
  get: async () => {
    const { data } = await api.get<ApiResponse<Flow>>('/flows/')
    return data
  },
  getById: async (id: number) => {
    const { data } = await api.get<Flow>(`/flows/${id}/`)
    return data
  },
  getAll: async () => {
    const { data } = await api.get<Flow[]>('/flows/all/')
    return data
  },
  add: async (payload: FlowPayload) => {
    const { data } = await api.post<Flow>('/flows/', payload)

    return data
  },
  update: async (id: number, payload: Partial<FlowPayload>) => {
    const { data } = await api.patch<Flow>(`/flows/${id}/`, payload)

    return data
  },
  delete: async (id: number) => {
    const { data } = await api.delete<Flow>(`/flows/${id}/`)

    return data
  }
}
